// extracted by mini-css-extract-plugin
export var audio_player = "index-module--audio_player--QDWBq";
export var belowArticleInfo = "index-module--below-article-info--gVp9I";
export var singlePublicationHeadline = "index-module--single-publication-headline--ZVjg3";